import messagesDe from './de.json';

export const messages = messagesDe;

